import * as React from "react";
import { useError } from "../hooks/useError";

const ErrorPage = () => {
  const { error } = useError();

  React.useEffect(() => {
    error();
  }, []);

  return <div>Redirecting...</div>;
};

export default ErrorPage;
